namespace $.$$ {

	export class $eve_app_page_components_flex extends $.$eve_app_page_components_flex {

	}

}
